/* NAMI Studio theme — global JS */
(function () {
  'use strict';

  /* ---- Hero carousel ---- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dot');
    if (!track || slides.length < 2) return;
    var i = 0, n = slides.length, timer;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;

    function go(idx) {
      i = (idx + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    function start() { if (autoplay) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { clearInterval(timer); }

    hero.querySelectorAll('[data-hero-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); stop(); start(); }); });
    hero.querySelectorAll('[data-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); stop(); start(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); stop(); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    go(0); start();
  });

  /* ---- Mobile menu ---- */
  var mt = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('.nav');
  if (mt && nav) {
    mt.addEventListener('click', function () {
      var open = nav.style.display === 'block';
      nav.style.display = open ? '' : 'block';
    });
  }

  /* ---- Product gallery thumb swap ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        if (main) main.src = th.getAttribute('data-full') || th.src;
      });
    });
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
      });
    });
  });

  /* ---- Newsletter / add-to-cart use native Shopify form posts; no JS needed ---- */
})();
